import React from "react";
import desktopLogo from "../../assets/images/company_logo.png";
import mobileLogo from "../../assets/images/company_logo_mobile.png";
import { Grid } from "antd";

export const Logo = ({
  mobile,
  onClick,
}: {
  mobile?: boolean;
  onClick?: () => void;
}) => {
  const { useBreakpoint } = Grid;
  const { xs } = useBreakpoint();
  const useMobileLogo = xs || mobile;
  if (useMobileLogo) {
    return (
      <img
        src={mobileLogo}
        alt="Quattro Support"
        width={150}
        height={150}
        className="logo-img-mobile"
        onClick={onClick}
        style={{ cursor: "pointer" }}
      />
    );
  } else {
    return (
      <img
        src={desktopLogo}
        alt="Quattro Support"
        width={464}
        height={471}
        className="logo-img"
        onClick={onClick}
        style={{ cursor: "pointer" }}
      />
    );
  }
};
